import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/user-bg.png'


const _withScopeId = n => (_pushScopeId("data-v-7e1d633e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"100%","height":"auto"}
}, null, -1))
const _hoisted_2 = { class: "main-con" }
const _hoisted_3 = {
  class: "cls-flex",
  style: {"padding-left":"3vw"}
}
const _hoisted_4 = { style: {"padding-left":"2vw","flex":"1"} }
const _hoisted_5 = { class: "name-con" }
const _hoisted_6 = { class: "desc-con" }
const _hoisted_7 = { class: "desc-con" }
const _hoisted_8 = { style: {"padding-left":"2vw"} }
const _hoisted_9 = { class: "tg-con" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "推广中心", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"font-size":"0.8rem"} }
const _hoisted_13 = { class: "item-con" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "常用功能", -1))
const _hoisted_15 = ["src"]
const _hoisted_16 = { style: {"font-size":"0.8rem"} }
const _hoisted_17 = { class: "qr-con" }
const _hoisted_18 = { class: "cls-flex" }
const _hoisted_19 = { style: {"padding-left":"0.5rem"} }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = {
  class: "desc",
  style: {"padding-top":"0.3rem"}
}
const _hoisted_22 = { style: {"padding":"0.2rem 1rem"} }
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          width: "16vw",
          height: "16vw",
          src: _ctx.user.thumb,
          radius: "9vw",
          fit: "cover"
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user.name), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, "账号：" + _toDisplayString(_ctx.user.phone), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(" 注册：" + _toDisplayString(_ctx.data.creatDate) + " ", 1),
            _createElementVNode("span", _hoisted_8, "到期：" + _toDisplayString(_ctx.data.bonusEndDate), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_van_grid, {
          "column-num": 4,
          border: false,
          clickable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.tgArr, (item) => {
              return (_openBlock(), _createBlock(_component_van_grid_item, {
                onClick: ($event: any) => (_ctx.tg_click(item))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: item.icon,
                      style: {"width":"3rem","height":"3rem"}
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 256))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_van_grid, {
          "column-num": 4,
          border: false,
          clickable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.comArr, (item) => {
              return (_openBlock(), _createBlock(_component_van_grid_item, {
                url: item.url
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: item.icon,
                      style: {"width":"3rem","height":"3rem"}
                    }, null, 8, _hoisted_15)
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["url"]))
            }), 256))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_van_button, {
        square: "",
        block: "",
        style: {"margin":"1.5rem 0 4rem","color":"#d8c14f"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ path:'/user' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode("切换为用户端")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.config.showQr,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.showQr) = $event)),
      round: "",
      closeable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_van_image, {
              src: _ctx.user.headImgurl,
              radius: "3rem",
              width: "3rem",
              height: "3rem",
              fit: "cover"
            }, null, 8, ["src"]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.user.name), 1),
              _createElementVNode("div", _hoisted_21, "ID:" + _toDisplayString(_ctx.user.id), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("img", {
              src: _ctx.user.tgQrUrl,
              style: {"width":"60vw","height":"60vw"}
            }, null, 8, _hoisted_23)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}